module.exports = __webpack_public_path__ + "img/snow-2.7d6dc0be.svg";